import {trans} from '@frontend/helpers'
import {usePageTitle} from '@shared/helpers/usePageTitle'
import type {ReactNode} from 'react'

interface Props {
    title?: string | null | undefined
    wrapTitle?: boolean
    description?: string | null
    noIndex?: boolean
    noFollow?: boolean
    // Другие <meta> теги.
    children?: ReactNode | ReactNode[]
}

// Задание meta-тегов.
export function MetaTags(props: Props) {

    const {
        title,
        wrapTitle = false,
        description,
        noIndex = false,
        noFollow = false,
        children,
    } = props

    // Задаем через docuument.title т.к. <title> создает дубликат в <head>,
    // если в <head> уже был встроен <title> в Laravel (react_app_blade.php).
    // Todo: вынести в React Router 'handle'.
    usePageTitle(
        wrapTitle && title
            ? trans().common.wrap_page_title(title)
            : title
    )

    return (
        <>
            {(noIndex || noFollow) && (
                <meta
                    name="robots"
                    content={
                        (noIndex ? 'noindex' : '')
                        + (noIndex && noFollow ? ', ' : '')
                        + (noFollow ? 'nofollow' : '')
                    }
                />
            )}
            {description !== null && (
                <>
                    <meta
                        name="description"
                        content={description ?? trans().common.meta_tags.defaultDescription}
                    />
                    <meta
                        name="og:description"
                        content={description ?? trans().common.meta_tags.defaultDescription}
                    />
                </>
            )}
            {children}
        </>
    )
}
